[
    {
        "ID": 1,
        "NAME": "stellantis"
    },
    {
        "ID": 2,
        "NAME": "ssangyong"
    },
    {
        "ID": 3,
        "NAME": "iveco"
    },
    {
        "ID": 4,
        "NAME": "melco"
    },
    {
        "ID": 5,
        "NAME": "mitsubishi"
    },
    {
        "ID": 6,
        "NAME": "opel"
    }
]